module.exports = __webpack_public_path__ + "36703d72d0d08c58004e8142c9e372d0.jpg";